var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-preview"},[_c('iframe',{attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.height,"frameborder":"0","vspace":"0","hspace":"0","allowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }